import { useContext, createContext, useState, useEffect } from "react";

import PropTypes from "prop-types";

import useContentAttachmentsGet from "@/content/useContentAttachmentsGet";
import getChecksForUnderstandingQuizAttachment from "@/view/utils/getChecksForUnderstandingQuizAttachment";

const propTypes = {
  children: PropTypes.node,
  contentId: PropTypes.string,
};

const AttachmentsContext = createContext();

export const AttachmentsContextProvider = ({ children, contentId }) => {
  const {
    data: attachments,
    loading,
    error,
  } = useContentAttachmentsGet(contentId);
  const [visibleActivityIds, setVisibleActivityIds] = useState(null);
  const [currentActivityCount, setCurrentActivityCount] = useState();

  useEffect(() => {
    const attachmentIds = attachments?.map((attachment) => attachment.id);
    if (!visibleActivityIds) {
      setVisibleActivityIds(attachmentIds);
    }
  }, [attachments]);

  const checksForUnderstandingQuiz =
    getChecksForUnderstandingQuizAttachment(attachments);
  return (
    <AttachmentsContext.Provider
      value={{
        attachments,
        currentActivityCount,
        error,
        loading,
        checksForUnderstandingQuiz,
        visibleActivityIds,
        setCurrentActivityCount,
        setVisibleActivityIds,
      }}
    >
      {children}
    </AttachmentsContext.Provider>
  );
};

AttachmentsContextProvider.propTypes = propTypes;

const useAttachmentsContext = () => {
  const attachmentsContext = useContext(AttachmentsContext);

  if (attachmentsContext === undefined) {
    throw new Error(
      "attachmentsContext must be used within a AttachmentsContextProvider.",
    );
  }

  return attachmentsContext;
};

export default useAttachmentsContext;
